import { get } from 'lodash';
import { config as _config } from '../config';

export class ConfigProvider {
  static config: any;

  static findConfig(key: string | null = null): { [key: string]: any } | null {
    if (!key) {
      return null;
    }
    if (!ConfigProvider.config) {
      ConfigProvider.config = _config;
    }

    let config: { [key: string]: any } | null = null;
    if (key) {
      config = get(ConfigProvider.config, key.split('/'));
    } else {
      config = ConfigProvider.config;
    }

    return config || null;
  }

  static hasConfig(key: string | null = null): boolean {
    return this.findConfig(key) !== null;
  }

  static getConfig(key: string | null = null): { [key: string]: any } {
    let config = this.findConfig(key);

    if (!config) {
      throw new Error(`configuration not found for key ${key}`);
    }

    return config;
  }
}



// WEBPACK FOOTER //
// ./src/utils/ConfigProvider.ts